import React from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';
import moment from 'moment';
import swal from 'sweetalert2';
import Chart from 'chart.js'

import { fetchStatsMasterLeagues } from "../../../../../actions/entities/statistics/masterLeague";

import Loader from "../../../../../components/Loader";
import classNames from "classnames";
import DateRangePickerWrapper from "../../../../../components/DatePicker/DateRangePickerWrapper";

import earthFlag from '../../../../../assets/img/other/flag-earth.svg';

import './index.css';

let chart;

class CreatedMasterLeague extends React.Component {
    constructor(props) {
        super(props);

        // We set the date to yesterday and we subtract 30 days
        const today = new Date();
        const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
        const start = moment(today.setDate(today.getDate() - 30 )).format('YYYY-MM-DD');

        this.state = { start, end, lang: 'ALL' }
    }

    fetchStats() {
        const { start, end } = this.state;
        const { isFetching } = this.props;
        if (!isFetching) {
            this.props.dispatch(fetchStatsMasterLeagues({
                startDate: start,
                endDate: end,
            }, null, (type, error) => swal({
                title: `Oops...`,
                type: 'error',
                html: `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                    `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
            })));
        }
    }

    componentDidMount() {
        const ctx = document.getElementById('master-leagues-stats-chart');
        if (ctx)
            chart = new Chart(ctx, {
                type: 'bar',
                data: {datasets: []},
                options: {
                    scales: {
                        xAxes: [{
                            id: 'date',
                            type: 'time',
                            stacked: true
                        }],
                        yAxes: [{
                            id: 'members',
                            type: 'linear',
                            stacked: true
                        }]
                    }
                }
            });
    }

    updateGraph(data) {
        const { creations } = data;
        const { lang } = this.state;

        const datasets = [{
            label: 'Nb Master League',
            backgroundColor: '#ed9728',
            xAxisID: 'date',
            yAxisID: 'members',
            data: []
        }];

        map(creations, stat => {
            datasets[0].data.push({x: moment(stat.date).format('LL'), y: parseInt(stat[lang], 10)});
        });

        chart.data.datasets = datasets;
        chart.update();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data !== this.props.data) {
            this.updateGraph(nextProps.data)
        }
    }

    componentDidUpdate() {
        this.props.data && this.updateGraph(this.props.data);
    }

    toggleLang(value) {
        const { lang } = this.state;

        if (lang === value) { this.setState({ lang: 'ALL' }) }
        else { this.setState({ lang: value }) }
    }

    renderTable(table, id) {
        if (!table) return false;

        return (
            <div className="mt-3 table-responsive">
                <table className="table table-striped">
                    <thead>
                    <tr className="bg-gray">
                        <th className="text-center">Ligue</th>
                        <th className="text-center">Nombre</th>
                        <th className="text-center">vs S-1</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td className="text-center">MasterLeague</td>
                      <td className="text-center">{table.current}</td>
                      <td className="text-center">{table.previous}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    renderLeaguesCreatedByMode() {
        const id = 'masterLeaguesCreated';
        const { data, isFetching } = this.props;
        const { lang } = this.state;
        const table = data && data[lang][id];

        return (!isFetching && table) && (
            <div id={id} className="mb-4">
                {this.renderTable(table, id)}
            </div>
        );
    }

    render() {
        const { end, start, lang } = this.state;
        const { isFetching } = this.props;

        return (
            <div id="leagues-stats-widget">
                <div className="box">
                    <div className="box-header with-border">
                        <h3 className="box-title pull-left">
                            <i className="fa fa-users"/> master league créées
                        </h3><br />
                        Nombres de master ligues crées entre le {this.state.start} et le {this.state.end}
                    </div>
                    <div className="box-body">
                        <div className="text-center">
                            <div className="inline lang">
                                <button
                                    className={classNames('btn btn-box-tool', { selected: lang === 'FR'})}
                                    onClick={() => this.toggleLang('FR')}
                                >
                                    <span className="flag-icon flag-icon-fr"/>
                                </button>
                                <button
                                    className={classNames('btn btn-box-tool', { selected: lang === 'GB' })}
                                    onClick={() => this.toggleLang('GB')}
                                >
                                    <span className="flag-icon flag-icon-gb"/>
                                </button>
                                <button
                                    className={classNames('btn btn-box-tool', { selected: lang === 'ES' })}
                                    onClick={() => this.toggleLang('ES')}
                                >
                                    <span className="flag-icon flag-icon-es"/>
                                </button>
                                <button
                                    className={classNames('btn btn-box-tool', { selected: lang === 'OTHER' })}
                                    onClick={() => this.toggleLang('OTHER')}
                                >
                                    <img src={earthFlag} alt="Drapeau de la terre" className="flag-img-btn" />
                                </button>
                            </div>
                            <div className="inline data-range-picker">
                                <DateRangePickerWrapper
                                    initialStartDate={moment(start)}
                                    initialEndDate={moment(end)}
                                    minimumNights={0}
                                    onDatesChange={({ startDate, endDate }) => {
                                        this.setState({
                                            start: moment(startDate).format('YYYY-MM-DD'),
                                            end: moment(endDate).format('YYYY-MM-DD')
                                        });
                                    }}
                                />
                                <button
                                    className="ml-2 inline btn btn-default"
                                    onClick={() => this.fetchStats()}
                                >
                                    <i className="fa fa-refresh"/>
                                </button>
                            </div>
                        </div>
                    </div>
                    {isFetching && <Loader/>}
                    {this.renderLeaguesCreatedByMode()}
                    <div className={classNames('chart', this.props.data ? 'displayGraphs' : 'notDisplayGraphs')}>
                        <canvas id="master-leagues-stats-chart"/>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => state.app.statistics.masterLeague.created,
    dispatch => ({ dispatch })
)(CreatedMasterLeague);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/MasterLeague/Created/index.js